import { render, staticRenderFns } from "./edit-global-supplement-dialog.vue?vue&type=template&id=82778200&scoped=true"
import script from "./edit-global-supplement-dialog.vue?vue&type=script&lang=js"
export * from "./edit-global-supplement-dialog.vue?vue&type=script&lang=js"
import style0 from "./edit-global-supplement-dialog.vue?vue&type=style&index=0&id=82778200&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82778200",
  null
  
)

export default component.exports